import { render, staticRenderFns } from "./PatientLayout.vue?vue&type=template&id=3346cfb1&scoped=true"
import script from "./PatientLayout.vue?vue&type=script&lang=js"
export * from "./PatientLayout.vue?vue&type=script&lang=js"
import style0 from "./PatientLayout.vue?vue&type=style&index=0&id=3346cfb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3346cfb1",
  null
  
)

export default component.exports